import CarrierAccountDetailsModal from 'app/views/modals/carrier_account_details_modal';
import DeleteCarrierAccountModal from 'app/views/modals/delete_carrier_account_modal';

import Base from 'app/views/base';

import tmpl from './item_template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .edit': 'showDetailsModal',
    'click .delete': 'showDeleteModal',
  },

  initialize() {
    this.detailsModal = new CarrierAccountDetailsModal({ model: this.model });

    this.deleteModal = new DeleteCarrierAccountModal({
      model: this.model,
      collection: this.collection,
    });

    this.listenTo(this.model, 'change', this.render);
  },

  context() {
    return {
      id: this.model.id,
      reference: this.model.get('reference'),
      type: this.model.get('type'),
      description: this.model.get('description'),
    };
  },

  showDetailsModal(event) {
    event.preventDefault();
    this.detailsModal.show();
  },

  showDeleteModal(event) {
    event.preventDefault();
    this.deleteModal.show();
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/carrier_accounts/carrier_accounts/item.js